<template>
<!-- offcanvas -->
<div class="offcanvas offcanvas-start custom-sidebar border-0" style="width: 280px;" tabindex="-1" id="sidebar" aria-labelledby="sidebar">
  <div class="offcanvas-header pb-0 mt-2">
    <h5 class="offcanvas-title text-muted small fw-bold text-uppercase ms-2">Menú Principal</h5>
    <button type="button" class="btn-close text-reset shadow-none" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  
  <div class="offcanvas-body pt-3">
    <!-- User Profile Section -->
    <div class="user-profile-section mb-4 animate__animated animate__fadeIn">
      <div class="avatar-container position-relative mb-3">
        <img src="img/users/logo.jpg" class="avatar-img shadow-sm" alt="User">
        <div class="status-indicator online"></div>
      </div>
      <div class="user-info">
        <h6 class="mb-0 text-dark fw-bold">{{ userl }}</h6>
        <span class="text-muted extra-small">Vendedor Autorizado</span>
      </div>
    </div>

    <div class="divider mb-3"></div>

    <!-- Navigation Menu -->
    <ul class="navbar-nav custom-nav">
      <li class="nav-item">
        <router-link class="sidebar-link" :to="{ name : 'mispedidosguardados' }">
          <div class="icon-box"><i class="bi bi-hdd-fill"></i></div>
          <span class="link-text">Archivos Guardados</span>
        </router-link>   
      </li>
      
      <li class="nav-item">
        <router-link class="sidebar-link" :to="{ name : 'mispedidos' }">
          <div class="icon-box"><i class="bi bi-send-fill"></i></div>
          <span class="link-text">Pedidos Enviados</span>
        </router-link>   
      </li>

      <li class="nav-item border-top mt-2 pt-2">
        <router-link class="sidebar-link" :to="{ name : 'miscuentasporcobrar' }">
          <div class="icon-box"><i class="bi bi-calculator-fill"></i></div>
          <span class="link-text">Cuentas por Cobrar</span>
        </router-link>   
      </li>         

      <li class="nav-item border-top mt-2 pt-2">
        <a href="#" @click.prevent="irahome" class="sidebar-link">
          <div class="icon-box"><i class="bi bi-cloud-arrow-down-fill"></i></div>
          <span class="link-text">Sincronizar Datos</span>
        </a>   
      </li>
    </ul>

    <!-- Bottom Actions -->
    <div v-if="loged" class="mt-auto pt-4 border-top">
      <a href="#" class="sidebar-link logout-link px-3" @click.prevent="logOut">
        <div class="icon-box text-danger"><i class="bi bi-box-arrow-left"></i></div>
        <span class="link-text text-danger">Cerrar Sesión</span>
      </a> 
    </div>
  </div>
</div>
</template>

<script setup>
  import { defineProps } from 'vue'
  import { useRouter } from 'vue-router'

  defineProps({
    loged : Boolean,
    userl : String
  })

  const router = useRouter()

  const irahome = ( async ()=>{
    localStorage.removeItem('last_sync_time')
    await router.push('/')
    location.reload()
  })

  const logOut = ( async ()=>{
    localStorage.removeItem('spx_localdata')
    localStorage.removeItem('spx_params')
    localStorage.removeItem('spx_mydata')
    localStorage.removeItem('spx_lastdoc')
    localStorage.removeItem('spx_clientlist')
    localStorage.removeItem('spx_priceslist')
    localStorage.removeItem('spx_marylist')
    localStorage.removeItem('spx_comentario')
    localStorage.removeItem('spx_lastreq')
    localStorage.removeItem('spx_orderslist')
    localStorage.removeItem('last_sync_time')
    localStorage.removeItem('spx_canales')
    location.reload()
  })

</script>

<style scoped>
  .custom-sidebar {
    background: #ffffff;
    box-shadow: 4px 0 24px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
  }

  .user-profile-section {
    text-align: center;
    padding: 1.5rem 1rem;
    background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
    border-radius: 1rem;
  }

  .avatar-container {
    display: inline-block;
  }

  .avatar-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #fff;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  }

  .status-indicator {
    position: absolute;
    bottom: 4px;
    right: 4px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid #fff;
  }

  .status-indicator.online { background-color: #28a745; }

  .extra-small { font-size: 0.7rem; letter-spacing: 0.5px; text-transform: uppercase; }

  .divider { height: 1px; background: rgba(0,0,0,0.06); }

  .custom-nav { gap: 4px; }

  .sidebar-link {
    display: flex;
    align-items: center;
    padding: 0.75rem 0.85rem;
    border-radius: 0.75rem;
    text-decoration: none;
    color: #444;
    font-weight: 500;
    font-size: 0.95rem;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .icon-box {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    margin-right: 12px;
    font-size: 1.1rem;
    transition: inherit;
  }

  .sidebar-link:hover {
    background: #f1f3f5;
    color: #000;
    transform: translateX(4px);
  }

  .sidebar-link.router-link-active {
    background: #e9ecef;
    color: var(--bs-primary);
    font-weight: 600;
  }

  /* Accento basado en el color base del sistema */
  .sidebar-link.router-link-active .icon-box {
    background: rgba(0, 0, 0, 0.05);
  }

  .logout-link:hover {
    background: #fff5f5;
  }

  .offcanvas-body {
    display: flex;
    flex-direction: column;
    padding-bottom: 2rem;
  }
</style>

